<template>
  <div class="apply-privilege">
    <Card shadow class="content">
      <div class="main">
        <Row class="title">
          <h4 :style="{float: 'left'}">申请权限</h4>
        </Row>
        <GeneralAlert></GeneralAlert>
        <Form inline :label-width="90" :rules="baseInfoFormRules" ref="baseInfo" :model="baseInfo">
          <FormItem label="实例" style="width: 100%" prop="instance">
            <Select v-model="baseInfo.instance" placeholder="请选择数据库实例" filterable transfer clearable @on-change="getDatabases" ref="execInstance" label-in-value>
              <OptionGroup label="MySQL">
                <Option v-for="item in instanceList.mysql" :value="'mysql_' + item.id" :key="'mysql_' + item.id">{{ item.name }}</Option>
              </OptionGroup>
              <!--<OptionGroup label="MongoDB">-->
              <!--<Option v-for="item in instanceList.mongodb" :value="'mongodb_' + item.id" :key="'mongodb_' + item.id">{{ item.name }}</Option>-->
              <!--</OptionGroup>-->
              <OptionGroup label="SQL Server">
                <Option v-for="item in instanceList.sqlserver" :value="'sqlserver_' + item.id" :key="'sqlserver_' + item.id">{{ item.name }}</Option>
              </OptionGroup>
            </Select>
          </FormItem>
          <FormItem label="数据库用户" style="width: 100%" prop="username">
            <Select v-model="baseInfo.username" placeholder="请选择数据库用户" filterable transfer multiple clearable ref="execUsername">
              <Option v-for="item in usernameList" :value="item.user" :key="item.user">{{ item.user }}</Option>
            </Select>
          </FormItem>
          <FormItem label="数据库" style="width: 100%" prop="database_name">
            <Select v-model="baseInfo.database_name" placeholder="请选择数据库" filterable transfer multiple @on-change="getTables" clearable ref="execDatabase">
              <Option v-for="item in databaseList" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem label="数据表" style="width: 100%" prop="table_name">
            <Select v-model="baseInfo.table_name" placeholder="请选择数据表" filterable transfer multiple clearable ref="execTable">
              <Option v-for="item in tableList" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem label="申请权限" style="width: 100%" prop="privileges">
            <Select v-model="baseInfo.privileges" placeholder="请选择要申请的权限" filterable transfer multiple @on-change="privilegesChange">
              <Option v-for="item in privilegeList" :value="item.value" :key="item.value"  :disabled="baseInfo.privileges.indexOf('ALL') > -1 && item.value !== 'ALL'">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="申请说明" style="width: 100%">
            <Input type="textarea" :maxlength="2048" v-model="baseInfo.application_content" :rows="6" placeholder="申请说明" />
          </FormItem>
        </Form>
        <div style="text-align: center;">
          <Button type="primary" style="margin-right: 10px" :loading="submitting" @click="submit">提交申请</Button>
          <Button @click="$router.go(-1)">取消</Button>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { dbReleaseFlowApplyPrivilege } from '@/api/workflow/db_release_flow'
import { getAllInstance } from '@/api/database'
import { showDatabaseList as showMysqlDatabaseList,
  getInstanceAllUserList as getMysqlInstanceUserList,
  showTableList as showMysqlTableList } from '@/api/mysql'
import { showDatabaseList as showSqlServerDatabaseList,
  getInstanceAllUserList as getSqlServerInstanceUserList,
  showTableList as showSqlServerTableList } from '@/api/sqlserver'
import GeneralAlert from '../components/general-alert'

export default {
  name: 'apply-privilege',
  components: {
    GeneralAlert
  },
  data () {
    return {
      instanceList: {
        mysql: [],
        mongodb: [],
        sqlserver: []
      },
      baseInfo: {
        instance: '',
        instance_name: '',
        application_content: '',
        username: [],
        privileges: [],
        table_name: [],
        database_name: []
      },
      usernameList: [],
      databaseList: [],
      tableList: [],
      privilegeList: [
        { value: 'ALL', label: 'all' },
        { value: 'INSERT', label: 'insert' },
        { value: 'DELETE', label: 'delete' },
        { value: 'UPDATE', label: 'update' },
        { value: 'SELECT', label: 'select' },
        { value: 'CREATE', label: 'create' },
        { value: 'INDEX', label: 'index' },
        { value: 'ALTER', label: 'alter' },
        { value: 'EVENT', label: 'event' },
        { value: 'EXECUTE', label: 'execute' },
        { value: 'CREATE VIEW', label: 'create view' },
        { value: 'CREATE ROUTINE', label: 'create routine' },
        { value: 'ALTER ROUTINE', label: 'alter routine' }
      ],
      baseInfoFormRules: {
        instance: { required: true, message: '请选择实例', trigger: 'change' },
        username: { required: true, message: '请选择数据库用户', type: 'array' },
        privileges: { required: true, message: '请选择要申请的权限', type: 'array' },
        database_name: { required: true, message: '请选择要数据库', type: 'array' }
      },
      submitting: false
    }
  },
  mounted: function () {
    this.getInstances()
  },
  watch: {
    '$store.state.user.defaultTenant' () {
      this.getInstances()
    }
  },
  methods: {
    submit () {
      this.$refs.baseInfo.validate((valid) => {
        if (valid) {
          this.baseInfo.instance_id = this.baseInfo.instance.split('_')[1]
          this.baseInfo.instance_type = this.baseInfo.instance.split('_')[0]
          this.submitting = true
          dbReleaseFlowApplyPrivilege(this.baseInfo).then(res => {
            this.$Notice.success({title: '操作成功'})
            this.$router.push({name: 'dbReleaseFlowDetail', params: { id: res.data.id }})
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    // 获取实例列表
    getInstances () {
      this.$refs.execInstance.clearSingleSelect()
      getAllInstance({ tenant_id__in: this.$store.state.user.defaultTenant }).then(res => {
        this.instanceList = res.data
      })
    },
    // 获取数据表
    getTables (database) {
      this.$refs.execTable.clearSingleSelect()
      this.tableList = []
      if (!database.length) {
        return
      }
      for (let i in database) {
        if (this.baseInfo.instance.split('_')[0] === 'mysql') {
          showMysqlTableList({ id: this.baseInfo.instance.split('_')[1], db: database[i] }).then(res => {
            let data = res.data.results
            for (let t in data) {
              data[t] = database[i] + '.' + data[t]
            }
            this.tableList = this.tableList.concat(data)
          })
        } else if (this.baseInfo.instance.split('_')[0] === 'sqlserver') {
          showSqlServerTableList({ id: this.baseInfo.instance.split('_')[1], db: database[i] }).then(res => {
            let data = res.data.results
            for (let t in data) {
              data[t] = database[i] + '.' + data[t]
            }
            this.tableList = this.tableList.concat(data)
          })
        }
      }
    },
    // 获取数据库
    getDatabases (instanceObj) {
      let instance = instanceObj.value
      this.baseInfo.instance_name = instanceObj.label
      this.$refs.execUsername.clearSingleSelect()
      this.$refs.execDatabase.clearSingleSelect()
      this.databaseList = []
      this.usernameList = []
      if (!instance) {
        return
      }
      let instanceId = instance.split('_')[1]
      let instanceType = instance.split('_')[0]
      if (instanceType === 'mysql') {
        showMysqlDatabaseList({ id: instanceId }).then(res => {
          this.databaseList = res.data.results
        })
        getMysqlInstanceUserList({ id: instanceId }).then(res => {
          this.usernameList = res.data.results
        })
      } else if (instanceType === 'sqlserver') {
        showSqlServerDatabaseList({ id: instanceId }).then(res => {
          this.databaseList = res.data.results
        })
        getSqlServerInstanceUserList({ id: instanceId }).then(res => {
          this.usernameList = res.data.results
        })
      }
    },
    // 选择申请权限触发
    privilegesChange (ps) {
      if (ps.indexOf('ALL') > -1) {
        this.baseInfo.privileges = ['ALL']
      }
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
</style>
